import React from 'react';
import { useSelector } from 'react-redux';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { useSocioeconomicChartsData } from '../../../../hooks/useSocioeconomicChartsData';
import { colorsPieCharts } from '../../../../shared/constants';
import { GenericChartCard } from '../../../../component/charts/genericChartCard';
import { ErrorState } from './errorState';
import {
  generateTitleAndSource,
  renderLegend,
} from './socioeconomicDemographicCharts';
import nls from '../nls/pt-BR.json';

export const TypesOfResidence: React.FC = () => {
  const { errorFetchData } =
    useSelector((state: any) => state.socioeconomicDemographicState) || '';
  const { typesOfResidenceFormattedData } = useSocioeconomicChartsData();
  return (
    <GenericChartCard
      title={generateTitleAndSource(
        nls.charts.typesOfResidence.typesOfResidence,
        nls.disclaimers.dataSourceIPTU2020
      )}
    >
      {errorFetchData?.typesOfResidence ? (
        <ErrorState />
      ) : (
        <ResponsiveContainer width="100%" height="75%">
          <PieChart width={400} height={400}>
            <Pie
              data={typesOfResidenceFormattedData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              labelLine={false}
              fill="#8884d8"
            >
              {typesOfResidenceFormattedData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colorsPieCharts[index % colorsPieCharts.length]}
                />
              ))}
            </Pie>
            <Legend
              verticalAlign="bottom"
              height={60}
              content={renderLegend(typesOfResidenceFormattedData)}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </GenericChartCard>
  );
};
